<template>
	<div>
		<div class="doctorPage" v-if="taskSecond">
			<tasksecondary-table />
		</div>
		<div class="doctorPage managerPlan" v-else>
			<div class="selectSearch" v-if='!splitScreen'>
			<el-form ref="form" :model="listParameter" class="qcFrom searchConditions" :inline="true" >
					<el-form-item label="状态">
					    <el-select v-model="listParameter.status" @change="selectChanged" placeholder="请选择" size="mini" style="width:160px" >
						<el-option label="全部" value="0" ></el-option>
						<el-option label="已创建" value="5" ></el-option>
						<el-option label="已抽样" value="10" ></el-option>
						<el-option label="已分配" value="15"></el-option>
						<el-option label="进行中" value="20"></el-option>
						<el-option label="已完成" value="50"></el-option>
						<el-option label="已取消" value="-1"></el-option>
					    </el-select>
					  </el-form-item>
					<el-form-item label="关键词">
						<el-input v-model="listParameter.keyword" class="name" placeholder="名称/评分方案/任务编号" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="创建时间">
						<el-date-picker class="time mar4" v-model="pickerDate.date" type="daterange" @change="datePicker" size="mini" range-separator="~" start-placeholder="开始时间" end-placeholder="结束时间">
						</el-date-picker>
					</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" @click="search" round>查询</el-button>
				</el-form-item>
				<div class="right-btn">
					<a href="javascript:;" @click="exportData" class="add-btn">数据导出</a>
					<a href="javascript:;" @click="newtasks" class="add-btn">新建任务</a>
				</div>
			</el-form>
			</div>
			<!-- 中间内容 -->
			<div class="centerHome" :class="splitScreen?'centerHomeActive':''">
				<div class="ccHomel">

					<div class="compentTable">
						<div>
							<task-table :list="list" />
						</div>
						<div class="pages">
							<el-pagination class="pageAll" layout="prev, pager, next" :total="total" :page-size='listParameter.PageCount' :current-page='listParameter.PageIndex' @current-change='currentChange'>
							</el-pagination>
						</div>
					</div>

				</div>
			</div>
		</div>
		
		<!-- 数据导出弹窗 -->
		<export-task-data :visible.sync="showExportDialog" />
	</div>
</template>
<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	import taskTable from '../../../components/manager/taskTable.vue'
	import exportTaskData from './exportTaskData.vue'

	export default {
		data() {
			return {
				showExportDialog: false
			}
		},
		components: {
			taskTable,
			exportTaskData,
		},
		computed: {
			...Vuex.mapState('managerPlanList', ['list', 'total', 'listParameter', 'splitScreen', 'pickerDate', 'taskSecond','loading','statusList'])
		},
		activated(){
			this.listParameter.startDate='';
			this.listParameter.endDate='';
			this.pickerDate.date = [];
		},
		methods: {
			...Vuex.mapMutations('managerPlanList', ['currentChanges', 'setDoctorStatus', 'setDatePicker', 'setSplitScreen', 'setTaskSecond','setLoading']),
			...Vuex.mapMutations('newtask', ['setPreviewFrom']),
			...Vuex.mapActions('managerPlanList', ['GetCreatedTaskList']),
			exportData(){
				this.showExportDialog = true
			},
			selectChanged(value){
				this.setLoading(true);
				this.currentChanges(1);
				this.setDoctorStatus(value);
				this.GetCreatedTaskList()
			},
			//分页
			currentChange(val) {
				this.setLoading(true);
				this.currentChanges(val)
				this.listParameter.status = this.statusList;
				this.setDoctorStatus(this.statusList);
				this.GetCreatedTaskList()
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			//搜索
			search() {
				this.setLoading(true);
				this.currentChanges(1)
				this.GetCreatedTaskList()
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			//创建日期
			datePicker(event) {
				this.setDatePicker(event)
			},
			//关闭分屏
			closeSplitScreen() {
				this.setLoading(false);
				this.setSplitScreen(false)
				this.setTaskSecond(false);
			},
			//创建任务
			newtasks() {
				this.setPreviewFrom();
				this.$router.push('/home/manager/task/taskall/newTask');
			},
			//返回
			backToPageUp() {
				this.setLoading(false);
				this.setTaskSecond(true);
				this.setSplitScreen(false);
				
			}
		}
	}
</script>

<style lang="scss" scoped>
.right-btn{
	position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -15px;
	display: flex;
	align-items: center;
	justify-content: space-between;
    .add-btn{
		text-align: center;
		display: block;
		background: #2EB4B5;
		color: #fff;
		border-radius: 40px;
		font-size: 12px;
		padding: 5px 19px;
		margin-right: 10px;
	}
}
</style>